import { DataHeader, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningProfileList extends Layout {
    dataheader2: DataHeader;
    sourceBrokeragePlanningProfile: DataSource;
    tableSearch: Table;
}
